import * as React from 'react'
import { connect } from 'react-redux'
import { WithTranslation } from 'react-i18next'
import { withTranslation } from 'react-i18next'
import { checklistFileComponentGetUploaded, checklistFileComponentUpload } from '../../../../redux/actions'
import IconComponent from '../../../../../inplant-components-fe/ui/components/MVIcon/Icon'
import { showNotification } from '@mv-submodules/mvlabs-components-fe/ui/components/Notification/Notification'
import FormComponentBuilder from '../../widgets/FormComponent/FormComponentBuilder'
import { ChecklistComponentFileData, EditComponentMetadataError } from '../../../../redux/reducers/checklistEdit'

export interface ComponentData {
  id: string
  optional: boolean
  type: {
    type: string
    values: string[]
  }
  defaultValue: string
  lastValue: string
}

export interface StateProps {
  componentData: ComponentData
  checklistInstanceId: string
  checkId: string
}

export interface DispatchProps {
  getFile: Function
  updateFile: Function
}

export interface OwnProps {
  collapseHandler?: Function
}

export type Props = StateProps & DispatchProps & OwnProps & WithTranslation

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: Function): DispatchProps => {
  return {
    getFile: (componentId: string) => dispatch(checklistFileComponentGetUploaded(componentId)),
    updateFile: (componentId: string, file: File, options: { hideNotification?: boolean }) =>
      dispatch(checklistFileComponentUpload(componentId, file, options)),
  }
}
/**
 * Style is wrong, doesn't works but it's not used anymore.
 */
export class FileComponent extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
    this.state = {
      loading: false,
      fileBlob: undefined,
    }
    this.updateFile = this.updateFile.bind(this)
    this.manageCollapsable()
    this.handleError = this.handleError.bind(this)
  }

  public componentDidMount() {
    if (this.props.componentData.lastValue) {
      this.props.getFile(this.props.componentData.id)
    }
  }

  private manageCollapsable() {
    if (this.props.componentData.lastValue && this.props.componentData.optional && this.props.collapseHandler) {
      this.props.collapseHandler()
    }
  }

  private async updateFile(event: React.ChangeEvent<HTMLInputElement>) {
    event.persist()
    const file = event.target.files?.[0]

    await this.props.updateFile(this.props.componentData.id, file, { hideNotification: true })
  }

  private handleError(error: EditComponentMetadataError) {
    if (!error || error.type !== 'server') {
      return
    }

    if (error.message?.includes('Invalid Exif')) {
      showNotification({ type: 'danger', message: this.props.t('checklist.edit.errors.invalidExif') })
    }
  }

  public render() {
    return (
      <div className="collapse cl-controls-optional cl-controls-optional-1 show">
        <FormComponentBuilder<ChecklistComponentFileData | undefined>
          className={'file-component'}
          component={this.props.componentData}
          onErrorReceived={this.handleError}
        >
          {({ updating, value, disabled, onBlur, className }) => {
            if (updating) {
              return (
                <div className="d-flex justify-content-center">
                  <IconComponent icon={'circle-notch'} className="spinner" spin={true} size="1x" />
                </div>
              )
            }

            if (value?.blob) {
              return <img className="img-fluid mx-auto d-block img-thumbnail" src={URL.createObjectURL(value?.blob)} />
            }

            return (
              <div className={`custom-file ${className}`}>
                <input
                  type="file"
                  className="custom-file-input"
                  id={`${this.props.componentData.id}-file`}
                  lang="it"
                  onChange={this.updateFile}
                  disabled={disabled}
                  onBlur={onBlur}
                />
                <label className="custom-file-label" htmlFor="customFileLang">
                  {this.props.t('checklist.components.browse')}
                </label>
              </div>
            )
          }}
        </FormComponentBuilder>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FileComponent))
